import React, { useState } from "react";
import '../animal/main.css';
import Header from "../../components/header";
import SiderBar from "./component/sidebar";
import { CloseOutlined } from "@mui/icons-material";
import Dashboard from "./page/dashboard";
import Transcation from "./page/transcation";
import { useRouter } from '../../router/hooks/index';
const IndexPage = () => {
    const [entitylist, setEntitylist] = useState([]);
    const [entity, setEntity] = useState('');
    const [sideState, setSideState] = useState(1);
    const router = useRouter();
    return (
        <div className="h--100 w--100">
            <Header entitylist = {entitylist} entity={entity} setEntity = {setEntity}/>
            <div className="animal_manage">
                <SiderBar setSideState={setSideState} sideState={sideState} />
                <div className="manage_content">
                    <div className="manage_title font-20-900">
                        <span>{sideState === 1 ? 'DASHBOARD' : 'TRANSAÇÕES'}</span>
                        <button className="btn_close font-13-900" onClick={()=>{router.push('/home');}}>
                             <CloseOutlined sx={{ fontSize: '24px' }} />
                        </button>
                    </div>
                    
                    {sideState === 1 ? <Dashboard /> : <Transcation />}
                    
                </div>
            </div>
        </div>
    );
}

export default IndexPage;